import { makeStyles } from "@material-ui/core";

const useLogoStyles = makeStyles(() => ({
    svg: {
      width: '100px', // Beispiel: Logo-Breite
      height: 'auto',
    },
    path: {
      fill: '#000', // Beispiel: Farbe des Logos
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }));
  
  export default useLogoStyles;
  